import "../assets/css/community.css";
import chevron_downIcon from "../assets/img/modals/chevron-down.svg"
import chevron_down_greyIcon from "../assets/img/chevron-down-gray.svg"
import tickIcon from "../assets/img/tick.svg"
import addUserIcon from "../assets/img/add-user.svg"
import exportIcon from "../assets/img/export-icon.svg"
import dotsIcon from "../assets/img/dots.svg"
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { useEffect, useState } from "react";
import * as $ from "jquery"
import { ChevronRight } from "../utils/svg";
import PageHeader from "../components/page-header";
import Skeleton from "react-loading-skeleton";
import SideBar from "../components/side-bar";
import getAudience, { getDefaultAudience } from "../services/getAudience";
import { useDispatch, useSelector } from "react-redux";
import { apiUrl, pageUrl, protocol } from "../utils/url";
import { toast } from "react-toastify";
import { hideLoader, showLoader } from "../components/loader";
import { audiencePosts } from "../services/postRequests/audience";
import ImportModal from "../components/audience/import-modal";
import setDateFormat, { formatISODate } from "../utils/setDateFormat";
import CommunityFooter from "../components/community/footer";
import HeaderSearch from "../components/community/headerSearch";
import ConfirmationModal from "../components/confirmation-modal";
import NewSideBar from "../components/side-bar/new-sidebar";
import EmptyState from "./empty-state";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import getProducts from "../services/getProducts";
import userIcon from "../assets/img/grey-user-icon.svg"
import EditLead from "../components/lead/edit-lead";

let params = []
export function arrayToCsvDownload(data, filename = "export.csv") {
    // Add UTF-8 BOM
    const BOM = "\uFEFF";
    
    // Helper function to escape CSV cells
    const escapeCsvCell = (cell) => {
        if (cell === null || cell === undefined) {
            return '';
        }
        cell = String(cell);
        // Escape quotes and wrap in quotes if contains comma, quote or newline
        if (cell.includes(',') || cell.includes('"') || cell.includes('\n')) {
            return `"${cell.replace(/"/g, '""')}"`;
        }
        return cell;
    };

    // Convert array to CSV string with proper escaping
    const csvString = BOM + data.map(row => {
        if (Array.isArray(row)) {
            // Handle header row
            return row.map(cell => escapeCsvCell(cell)).join(',');
        } else {
            // Handle data rows
            return Object.values(row).map(cell => escapeCsvCell(cell)).join(',');
        }
    }).join('\n');

    // Create and download the file
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}
const Audience = () => {
    const [loading, setloading] = useState(true);
    const { slug , basePath } = useSelector(state => state?.slugReducer);
    const [allAudience, setallAudience] = useState([]);
    const [allDefaultAudience, setallDefaultAudience] = useState([]);
    const [confirmationModalShow, setconfirmationModalShow] = useState({ show: false, text: null, deleteAll: null});
    const [isConfirmMessage, setisConfirmMessage] = useState(false)
    const [showImportModal, setshowImportModal] = useState(false)
    const [selectAll, setSelectAll] = useState(false)
    const [selectedRows, setSelectedRows] = useState([]); 
    const [selectedFilters, setSelectedFilters] = useState([]); 
    const [selectedCampaigns, setSelectedCampaigns] = useState([]);
    // const [allCampaigns, setAllCampaigns] = useState([]); 
    const allCampaigns = useSelector(state => state?.campgignsListReducer);
    const customizeDomainsReducer = useSelector(state => state?.customizeDomainsReducer);
    const history = useHistory();
    const dispatch = useDispatch();
    const [selectType,setSelectType] = useState('this_page');
    const [generatingStates, setGeneratingStates] = useState([]);
    const [unChecked, setUnChecked] = useState([]);
    const [newVariable, setNewVariable] = useState();
    const [filter, setfilter] = useState({
        page: 1,
        orderBy: null,
        filter: null,
        orderType: "asc",
        count: localStorage?.leads_count ?? 10
    })
    const variables = useSelector(state => state?.variablesReducer);
    const predefinedVariables =   new Set(['company_name', 'lead_first_name', 'email', 'ignore']);
    const [showEditLead, setShowEditLead] = useState({show:false});
    $(document).on('click', '.filter-dropdown-menu li a', function () {
        $('.filter-dropdown-menu li a').removeClass('active');
        $(this).addClass('active');
        $('.filter-dropdown-menu-selected').text($(this).attr('data-value'));
    });

    // useEffect(() => {
    //     // showLoader()
    //     getDefaultAudience(slug).then((response) => {
    //         setloading(false)
    //         setallDefaultAudience(response);
    //         // hideLoader()
    //     })
    // }, [slug]);

    useEffect(() => {
        params = [];
        if (slug) {
            for (const key in filter) {
                if (Object.hasOwnProperty.call(filter, key)) {
                    if (filter[key])
                        params.push(`${[key]}=${filter[key]}`)
                }
            };
            if (filter?.page) unCheckedToAll(); callAudience()
        }
    }, [slug, filter, selectedCampaigns]);

    const selectFilter = (e,val) => setfilter({ ...filter, filter: val ? val : 'all' })
    const callAudience = () => {
        // showLoader()
        setloading(true);
        const campaignFilter = selectedCampaigns.length > 0 ?  selectedCampaigns.map((id, index) => `campaign_ids[${index}]=${id}`).join("&") : '';
        const filterParams = params?.join("&");
        const queryParams = [filterParams, campaignFilter].filter(Boolean).join("&");
    
        getAudience(slug, queryParams).then((response) => {
            setloading(false);
            setallAudience(response);
            // hideLoader();
        })
    }
    const unCheckedToAll = () => {
        setUnChecked([]);
        setSelectedRows([]);
        setSelectAll(false);
        const checkbox = document.querySelector('input[data-id="select-all"]');
        if (checkbox) {
            checkbox.checked = false;
            // handleCheckboxChange({ target: checkbox }, 'select-all','dropdown-all');
        }
    }
    const filterToggler = (e, value) => {
        setfilter({
            ...filter,
            "orderBy": !$(e.target).hasClass("sortable-col-desc") ? value : value,
            orderType: !$(e.target).hasClass("sortable-col-desc") ? "desc" : "asc"
        })

        if ($(e.target).hasClass('sortable-col-desc')) {
            $('.sortable-col').removeClass('sortable-col-desc');
        }
        else {
            $('.sortable-col').removeClass('sortable-col-desc');
            $(e.target).addClass('sortable-col-desc');
        }
    };

    const unsubscribeAudience = async (id) => {
        showLoader();
        const api = apiUrl + "/community/subscribers/unsubscribe";
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const form_data = new FormData();
        form_data.append("subscriber", id)
        const setOptions = {
            method: "POST",
            headers: myHeaders,
            body: form_data
        }
        audiencePosts(api, hideLoader, setOptions).then(() => callAudience())
    };

    const deleteAudience = (id) => {
        // showLoader();
        const api = apiUrl + "/community/subscribers/delete/" + id;
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const setOptions = {
            method: "DELETE",
            headers: myHeaders,
        }
        audiencePosts(api, hideLoader, setOptions).then(() => {
            setconfirmationModalShow({ show: false, text: null, id: null, deleteAll: null })
            callAudience()
        }).catch(() => {
                setconfirmationModalShow({ show: false, text: null, id: null, deleteAll: null })
                hideLoader()
            })
    }
    const copyEmail = (email) => navigator.clipboard.writeText(email).then((r => toast.success("Successfully Copied")))

    const openImportModal = () => setshowImportModal(true)
    const handleHide = () => setshowImportModal(false);
    const sendTocampaigns = () => {
        history.push(basePath + "/campaigns")
    }
    const exportCSV = () => {
        showLoader();
        const api = apiUrl + "/community/subscribers/export-csv";
        const formdata = new FormData();
        formdata.append("project", slug)
        var inputs = null;
        if (selectType == 'this_page') { 
            formdata.append("type", selectType);  
            inputs = document.querySelectorAll('input[name="select-one"]:checked');
            inputs.forEach(input => {
                formdata.append("selectedIds[]", input.dataset.id);
            });
        }else if (selectedCampaigns?.length > 0) {
            selectedCampaigns.forEach(id => {
                formdata.append("selectedCampaigns[]", id);
            });
        }else {
            formdata.append("type", selectType);
        }
        unChecked.forEach(id => {
            formdata.append("unChecked[]",id)
        });
        formdata.append("lead_type", filter?.filter ?? 'all');
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const setOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata
        }
        if (selectedRows?.length || selectedCampaigns?.length && selectType && 'this_page') {
            audiencePosts(api, hideLoader, setOptions).then((response) => {
                // console.log("response?.data",response?.data)
                arrayToCsvDownload(response?.data,'leads.csv');
                if (inputs) {
                inputs.forEach(input => {
                    input.checked = false;
                });
                const selectAllCheckbox = document.querySelector('input[name="select-all"]');
                if (selectAllCheckbox) {
                    selectAllCheckbox.checked = false;
                }
                setSelectAll(false)
                setSelectedRows([]);
                }
                // callAudience()
            }).catch(() => {
                setconfirmationModalShow({ show: false, text: null, id: null, deleteAll: null })
                hideLoader()
            })
        }else{
            audiencePosts(api, hideLoader, setOptions, "export")
        }
        
    }

    const deleteAllAudience = (ids) => {
        // showLoader();
        const api = apiUrl + "/community/subscribers/delete-all";
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        var formData = new FormData();
        formData.append('slug',slug);
        let inputs;
        if (selectType == 'this_page') { 
        formData.append("type", selectType);  
        inputs = document.querySelectorAll('input[name="select-one"]:checked');
        inputs.forEach(input => {
            formData.append("id[]", input.dataset.id);
        });
        }else if (selectedCampaigns?.length > 0) {
            selectedCampaigns.forEach(id => {
                formData.append("selectedCampaigns[]", id);
            });
        }else {
            formData.append("type", selectType);
        }
        unChecked.forEach(id => {
            formData.append("unChecked[]",id)
        });
        formData.append("lead_type", filter?.filter ?? 'all');
        const setOptions = {
            method: "POST",
            headers: myHeaders,
            body: formData,
        }
        audiencePosts(api, hideLoader, setOptions).then(() => {
            setconfirmationModalShow({ show: false, text: null, id: null, deleteAll: null })
            inputs.forEach(input => {
                input.checked = false;
            });
            const selectAllCheckbox = document.querySelector('input[name="select-all"]');
            if (selectAllCheckbox) {
                selectAllCheckbox.checked = false;
            }
            setSelectAll(false)
            setSelectedRows([]);
            callAudience()
        }).catch(() => {
                setconfirmationModalShow({ show: false, text: null, id: null, deleteAll: null })
                hideLoader()
            })
    }
    const landingUrl = (val) => {
        const domain = val?.product?.branding?.custom_domain ?? customizeDomainsReducer?.domain;
        const isCompanyName = val?.product?.domain_type === 'company_name';
        // console.log("domain",domain)
        let link = domain ? (!domain?.includes('https://') ? 'https://'+domain : domain)+'/' : `${protocol + slug +'.'+ pageUrl}/`;
        link += isCompanyName ? val?.company_name_slug : val?.lead_slug;
        
        return link;
    };
    const copyLink = (val) => {
        const link = landingUrl(val);
        navigator.clipboard.writeText(link)
          .then(() => toast.success("Successfully Copied"))
          .catch(error => console.error('Error copying text: ', error));
    };
    const handleCheckboxChange = (e, id, type = null) => {
        if (id === 'select-all') {
            const inputs = document.querySelectorAll('input[name="select-one"]');
            inputs.forEach(input => {
                setUnChecked([])
                input.checked = e.target.checked;
                // if(type == 'dropdown-all'){
                //     input.disabled = e.target.checked;
                // }
                if (e.target.checked) {
                    if (!selectedRows?.includes(input?.dataset?.id)) {
                        setSelectedRows(selectedRows => [...selectedRows, input?.dataset?.id]);
                    }
                } else {
                    setSelectType('this_page');
                    setSelectedRows([]);
                }
            });
        }  else {
            if (e.target.checked) {
                if (selectType !== 'all') {
                    if (!selectedRows?.includes(id)) {
                        setSelectedRows([...selectedRows, id]);
                    }
                }
                    const updatedUnChecked = unChecked.filter(rowId => rowId != id);
                setUnChecked(updatedUnChecked);
            } else {
                const selectAllCheckbox = document.querySelector('input[name="select-all"]');
                if (selectAllCheckbox) {
                    selectAllCheckbox.checked = false;
                    setUnChecked([...unChecked, id]);
                }
                const updatedSelectedRows = selectedRows.filter(rowId => rowId != id);
                setSelectedRows(updatedSelectedRows);
            }
        }    
    };
    const addFilter = (val) => {
        setSelectedFilters([...selectedFilters, val?.name]);
        setSelectedCampaigns([...selectedCampaigns, val?.id]);
    };
    const callAllCampaigns = () => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const api = apiUrl + `/community/subscribers/campaigns/`+slug;
        const setOptions = {
            method: "GET",
            headers: myHeaders
        };
        audiencePosts(api, hideLoader, setOptions).then((response) => {
            if (response) {
                setAllCampaigns(response)
            }
        })
    }
    // useEffect(()=>{
    //     if (slug) {
    //         callAllCampaigns();
    //     }
    // },[slug])
    const removeFilter = (index) => {
        setSelectedFilters((prevFilters) => {
            const filters = [...prevFilters];
            filters.splice(index, 1);
            return filters;
        });
        setSelectedCampaigns((prevCampaigns) => {
            const campaigns = [...prevCampaigns];
            campaigns.splice(index, 1);
            return campaigns;
        });

    }
    const editProduct = (values) => {

        history.push({
            pathname: basePath + "/campaign/"+ values?.id + "/leads", state: {
                product_id: values?.id,
                edit: { is: true, id: values?.id }
            }
        });
    }
    const selectTypeClick = (type) => {
        const exportDropdown = document.querySelector('.export-dropdown');
        if (exportDropdown) {
            exportDropdown.style.display = 'none';
            setTimeout(() => {
              exportDropdown.style.display = '';
            }, 10);
        }
        const checkbox = document.querySelector('input[data-id="select-all"]');
        if (checkbox) {
            checkbox.checked = true;

            handleCheckboxChange({ target: checkbox }, 'select-all','dropdown-all');
        }

        setSelectType(type);
    }
    const handleGenerate = (val, index) => {
        if (val.is_exported) {
          const link = landingUrl(val);
          window.open(link, '_blank');
        } else {
          const newGeneratingStates = [...generatingStates];
          newGeneratingStates[index] = true;
          setGeneratingStates(newGeneratingStates);
          handleGeneratePage(val.id, index);
        }
      };
    
      const handleGeneratePage = (id, index) => {
        const api = `${apiUrl}/community/subscribers/generate-landing-page/${slug}/${id}`;
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const setOptions = {
          method: "GET",
          headers: myHeaders,
        };
    
        fetch(api, setOptions)
          .then(async (res) => {
            const response = await res.json();
            if (response?.status_code === 200) {
              const updatedData = [...allAudience.data];
              updatedData[index] = { ...updatedData[index], is_exported: true };
              setallAudience({ ...allAudience, data: updatedData });
              
              const newGeneratingStates = [...generatingStates];
              newGeneratingStates[index] = false;
              setGeneratingStates(newGeneratingStates);
    
              const landingText = document.querySelector(`.landing-page-text-${id}`);
    
              if (landingText) {
                landingText.classList.add('opacity-1');
              }
              toast.success(response?.status_message);
            }
          })
          .catch((error) => {
            console.error("Error generating landing page:", error);
            const newGeneratingStates = [...generatingStates];
            newGeneratingStates[index] = false;
            setGeneratingStates(newGeneratingStates);
          });
      };
      const handleAddVariable = () => {
        // Append the new variable to your array
        if (newVariable && newVariable?.trim() && !variables.includes(newVariable)) {
          showLoader();
          var myHeaders = new Headers();
          myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
          var formdata = new FormData();
          formdata.append("project", slug)
          formdata.append("new_variable", newVariable)
          const api = apiUrl + '/project/add-variable';
          const setOptions = {
            headers: myHeaders,
            body: formdata,
            method: 'POST'
          }
          fetch(api, setOptions).then(async (res) => {
            const response = await res.json();
            if (response?.status_code == 200) {
              dispatch({ type: "SET_VARIABLES", payload: [...variables, newVariable] })
              setNewVariable('');
              toast.success(response?.status_message);
              hideLoader();
            } else {
            //   setError(Object.values(response?.errors));
              toast?.error(response?.status_message)
              hideLoader();
            }
          }).catch((error) => {
            toast?.error(error)
            hideLoader()
    
          })
        } else {
          toast.error("Please add a valid variable");
        }
      };
    const editLead = (values) => {
        setShowEditLead({ show: true, leadData: values });
    }
    return (
        <div id="wrapper">
            <PageHeader />
            <div class="community-main new-sidebar">
                <NewSideBar from={"audience"}/>
                {/* <SideBar from="audience" /> */}

                <section class="community-section pb-0">

                    <div class="section-header sec-head-u">
                        <h1 class="mb-0">Leads  </h1>
                        <div class="d-flex flex-wrap align-items-center justify-content-end gap-1">
                            {selectedRows?.length > 0 &&
                                <button className="delete-all-btn" onClick={() => setconfirmationModalShow({show: true, text: "Are you sure you want to delete lead?", id: selectedRows, callBackTo: "delete", deleteAll: true})}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                                        <path d="M8.77364 0.564453C9.54452 0.564453 10.1761 1.17108 10.2319 1.94053L10.2359 2.05151V3.53857H12.4293C12.8331 3.53857 13.1605 3.87146 13.1605 4.2821C13.1605 4.6634 12.8782 4.97767 12.5146 5.02062L12.4293 5.02562H12.3789L11.8418 12.6728C11.736 14.179 10.54 15.3569 9.07236 15.4313L8.92474 15.435H4.23572C2.75088 15.435 1.51038 14.3057 1.33282 12.8223L1.31862 12.6728L0.780849 5.02562H0.731137C0.327341 5.02562 0 4.69274 0 4.2821C0 3.90079 0.282235 3.58652 0.645858 3.54357L0.731137 3.53857H2.92455V2.05151C2.92455 1.26756 3.52104 0.625299 4.27767 0.568532L4.38682 0.564453H8.77364ZM10.9122 5.02562H2.24749L2.77719 12.5669C2.82639 13.2672 3.34705 13.8256 4.00996 13.9303L4.1217 13.9435L4.23572 13.948H8.92474C9.65355 13.948 10.2646 13.4038 10.3708 12.6822L10.3833 12.5669L10.9122 5.02562ZM5.11796 7.25621C5.49291 7.25621 5.80195 7.54324 5.84418 7.91303L5.84909 7.99974V10.9739C5.84909 11.3845 5.52175 11.7174 5.11796 11.7174C4.743 11.7174 4.43396 11.4304 4.39173 11.0606L4.38682 10.9739V7.99974C4.38682 7.5891 4.71416 7.25621 5.11796 7.25621ZM8.0425 7.25621C8.41745 7.25621 8.72649 7.54324 8.76873 7.91303L8.77364 7.99974V10.9739C8.77364 11.3845 8.4463 11.7174 8.0425 11.7174C7.66755 11.7174 7.35851 11.4304 7.31627 11.0606L7.31137 10.9739V7.99974C7.31137 7.5891 7.63871 7.25621 8.0425 7.25621ZM8.77364 2.05151H4.38682V3.53857H8.77364V2.05151Z" fill="#FF2020"/>
                                    </svg>
                                    <span>Delete </span>
                                </button>
                                                    
                            }
                            <button class="project-blue-btn " onClick={exportCSV}>
                                {selectedRows?.length > 0 ? 'Export Selected':'Download CSV'}
                            </button>
                            <HeaderSearch filter={filter} setfilter={setfilter} name="leads" />

                            {/* <button class="btn btn-light btn-semi-rounded import-btn px-3 py-2 me-2 ms-2 d-flex align-items-center justify-content-center btn-import" onClick={openImportModal}>
                                <img src={addUserIcon} width="14px" alt="" />
                                <span>Import</span>
                            </button> */}
                        </div>
                    </div>
                    <div className="mt-20px d-flex justify-content-between align-items-center flex-wrap gap-2">
                        <div className="d-flex justify-content-start gap-1">
                            <div class="filter-action-dropdown  dropdown-toggle noselect d-flex align-items-center justify-content-end dropdown-subscribers" id="filter-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false" >
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                                        <rect y="0.5" width="15" height="15" rx="3" fill="#1188FF" />
                                        <path d="M3 6.5L9 6.5M9 6.5C9 7.32843 9.67157 8 10.5 8C11.3284 8 12 7.32843 12 6.5C12 5.67157 11.3284 5 10.5 5C9.67157 5 9 5.67157 9 6.5ZM6 10.5L12 10.5M6 10.5C6 11.3284 5.32843 12 4.5 12C3.67157 12 3 11.3284 3 10.5C3 9.67157 3.67157 9 4.5 9C5.32843 9 6 9.67157 6 10.5Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                                <span>
                                    Filter Campaigns
                                </span>
                            </div>
                            <ul class="filter-dropdown-menu dropdown-menu" aria-labelledby="filter-action-dropdown">
                                {allCampaigns?.length > 0 && 
                                    allCampaigns?.map((val,index)=> {
                                        const isSelected = selectedFilters.includes(val?.name);
                                        return (
                                            <li key={index} onClick={() => !isSelected && addFilter(val)} className={`filter-dropdown-item ${isSelected ? 'active' : ''}`}>
                                            <span>{val?.name}</span>
                                            {isSelected &&
                                            <img src={tickIcon} width={9} alt=""/>}
                                            </li>
                                        )})
                                }
                            </ul>
                            <div class="filter-action-dropdown  dropdown-toggle noselect d-flex align-items-center justify-content-end dropdown-subscribers" id="filter-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false" >
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                                        <rect y="0.5" width="15" height="15" rx="3" fill="#1188FF" />
                                        <path d="M3 6.5L9 6.5M9 6.5C9 7.32843 9.67157 8 10.5 8C11.3284 8 12 7.32843 12 6.5C12 5.67157 11.3284 5 10.5 5C9.67157 5 9 5.67157 9 6.5ZM6 10.5L12 10.5M6 10.5C6 11.3284 5.32843 12 4.5 12C3.67157 12 3 11.3284 3 10.5C3 9.67157 3.67157 9 4.5 9C5.32843 9 6 9.67157 6 10.5Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                                <span>
                                    All Leads
                                </span>
                            </div>
                            <ul class="filter-dropdown-menu dropdown-menu" aria-labelledby="filter-action-dropdown">
                                <li className={`filter-dropdown-item`} onClick={(e) => selectFilter(e,'all')}>
                                    <span>All Leads</span>
                                    {(!filter?.filter || filter?.filter == 'all') && <img src={tickIcon} width={9} alt=""/>}
                                </li>
                                <li className={`filter-dropdown-item`} onClick={(e) => selectFilter(e,'imported')}>
                                    <span>Imported Leads</span>
                                    {filter?.filter == 'imported' && <img src={tickIcon} width={9} alt=""/>}
                                </li>
                                
                                <li className={`filter-dropdown-item`} onClick={(e) => selectFilter(e,'exported')}>
                                    <span>Exported Leads</span>
                                    {filter?.filter == 'exported' && <img src={tickIcon} width={9} alt=""/>}
                                </li>
                                        
                            </ul>
                            <div className="d-flex align-items-center flex-wrap gap-1">
                            {
                                
                                selectedFilters?.length > 0 &&
                                    selectedFilters?.map((val, index) => (
                                        <div className="selected-filter" key={index}>
                                            <span>{val}</span>
                                            <span className="cursor-pointer" onClick={() => removeFilter(index)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="10" viewBox="0 0 9 10" fill="none">
                                                <path d="M8 1.5L1 8.5M1 1.5L8 8.5" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            </span>
                                        </div>
                                    ))
                            }
                            </div>
                        </div>
                        <div className="d-flex align-items-center zaapGlobal-input ps-2 p-0 w-auto">
                            <input
                            type="text"
                            value={newVariable}
                            onChange={(e) => setNewVariable(e.target.value)}
                            placeholder="Add new variable"
                            />
                            <button type="button" className="variable-dropdown" onClick={handleAddVariable}>
                            Add
                            </button>
                        </div>
                    </div>
                    
                    {!allAudience?.data?.length > 0?
                        <div class="section-main sec-main-u p-0 position-relative">
                            <EmptyState from={"leads"} search={filter?.search} firstText={'Import Leads From A Campaign'} secondText={"Create a campaign, and import leads to generate a custom landing page for each one."} clickedFunction={sendTocampaigns} buttonText={<span>Go to Campaigns <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 25" fill="none"><path d="M15.1696 6C17.273 7.55556 19.1622 9.37278 20.7905 11.4057C20.9302 11.5801 21 11.79 21 12M15.1696 18C17.273 16.4444 19.1622 14.6272 20.7905 12.5943C20.9302 12.4199 21 12.21 21 12M21 12H3" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>}/>
                        </div>
                    :
                    <div class="section-main sec-main-u">
                      

                        <div class="d-flex table-responsive leads-table">
                            <table class="table" border="0">
                                <thead class="d-md-table-header-group dashview-u">
                                    <tr>                                        
                                        <th scope="col" className={`aud-leftborder thead-padd aud-text ${selectAll ? ' selected':''}`}>
                                            {allAudience?.data?.length > 0 &&
                                            <span className="custom-checkbox-dropdown">
                                            {/* <label className="custom-checkbox checkbox me-0"> */}
                                                <input className="ui-checkbox" type="checkbox" name="select-all" data-id="select-all" onChange={(e) => handleCheckboxChange(e, 'select-all')}/>
                                                {/* <span className="checkmark"></span>
                                            </label> */}
                                            <ul className="filter-dropdown-menu dropdown-menu export-dropdown" style={{width:"181px",zIndex:999}}aria-labelledby="header-dropdown">
                                               <li className="filter-dropdown-item dropdown-item justify-content-start gap-2 align-items-center" onClick={() => selectTypeClick('this_page')}>
                                               {/* <input 
                                                    type="checkbox" 
                                                    className="ui-checkbox me-0" 
                                                    onClick={(e) => e.stopPropagation()}
                                                    onChange={() => selectTypeClick('this_page')}
                                                    checked={selectedRows?.length > 0 && selectType === 'this_page'}
                                                /> */}
                                                    Select this page ({allAudience?.to})
                                                </li>
                                               <li className="filter-dropdown-item dropdown-item justify-content-start gap-2 align-items-center" onClick={() => selectTypeClick('all')}>
                                               {/* <input 
                                                    type="checkbox" 
                                                    className="ui-checkbox me-0" 
                                                    onClick={(e) => e.stopPropagation()}
                                                    onChange={() => selectTypeClick('all')}
                                                    checked={selectedRows?.length > 0 && selectType === 'all'}
                                                /> */}
                                                    Select all leads ({allAudience?.total})
                                                </li>
                                            </ul>
                                            </span>
                                            }
                                            
                                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
                                            <path d="M12 13C12 12.0696 12 11.6044 11.8816 11.2259C11.615 10.3736 10.9272 9.70669 10.0483 9.44816C9.65793 9.33333 9.1782 9.33333 8.21875 9.33333H4.78125C3.8218 9.33333 3.34207 9.33333 2.95171 9.44816C2.07281 9.70669 1.38503 10.3736 1.11841 11.2259C1 11.6044 1 12.0696 1 13M9.59375 4C9.59375 5.65685 8.20863 7 6.5 7C4.79137 7 3.40625 5.65685 3.40625 4C3.40625 2.34315 4.79137 1 6.5 1C8.20863 1 9.59375 2.34315 9.59375 4Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            <span className="ms-2">
                                                Name
                                            </span>
                                                
                                        </th>
                                        <th scope="col" className={`thead-padd`}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                                            <path d="M8.63358 2.00886L13.5268 5.33677C13.6997 5.45436 13.7861 5.51316 13.8488 5.59159C13.9042 5.66101 13.9459 5.74131 13.9713 5.82779C14 5.92548 14 6.03337 14 6.24914V11.2355C14 12.3782 14 12.9495 13.7875 13.386C13.6005 13.7699 13.3022 14.082 12.9353 14.2776C12.5182 14.5 11.9721 14.5 10.88 14.5H4.12C3.0279 14.5 2.48185 14.5 2.06472 14.2776C1.6978 14.082 1.39949 13.7699 1.21254 13.386C1 12.9495 1 12.3782 1 11.2355V6.24914C1 6.03337 1 5.92548 1.02871 5.82779C1.05413 5.74131 1.09578 5.66101 1.15122 5.59159C1.21386 5.51316 1.30031 5.45436 1.47321 5.33677L6.36642 2.00886M8.63358 2.00886C8.22327 1.72981 8.01811 1.59028 7.79707 1.53599C7.60168 1.488 7.39832 1.488 7.20293 1.53599C6.98189 1.59028 6.77673 1.72981 6.36642 2.00886M8.63358 2.00886L13.3292 5.20242C13.5528 5.35446 13.6646 5.43048 13.7033 5.52688C13.7371 5.61113 13.7371 5.70608 13.7033 5.79033C13.6646 5.88673 13.5528 5.96275 13.3292 6.11479L8.63358 9.30835C8.22327 9.5874 8.01811 9.72693 7.79707 9.78122C7.60168 9.8292 7.39832 9.8292 7.20293 9.78122C6.98189 9.72693 6.77673 9.5874 6.36642 9.30835L1.67075 6.11479C1.4472 5.96275 1.33543 5.88673 1.29672 5.79033C1.26289 5.70608 1.26289 5.61113 1.29672 5.52688C1.33543 5.43048 1.4472 5.35446 1.67075 5.20242L6.36642 2.00886" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                            <span className="ms-2">
                                                Email Address
                                            </span>
                                        </th>
                                        <th scope="col" className={`thead-padd`}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                                            <path d="M1 8H14M1 8C1 11.5899 3.91015 14.5 7.5 14.5M1 8C1 4.41015 3.91015 1.5 7.5 1.5M14 8C14 11.5899 11.0899 14.5 7.5 14.5M14 8C14 4.41015 11.0899 1.5 7.5 1.5M7.5 1.5C9.12583 3.27993 10.0498 5.58982 10.1 8C10.0498 10.4102 9.12583 12.7201 7.5 14.5M7.5 1.5C5.87417 3.27993 4.95021 5.58982 4.9 8C4.95021 10.4102 5.87417 12.7201 7.5 14.5" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        <span className="ms-2">
                                                Company Name
                                        </span>
                                        </th>
                                        <th scope="col" className={`thead-padd`}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M8 14C10.6787 11.8171 10.7261 16.2383 14 12.6667M2.04411 12.2101C2.05031 11.9587 2.05341 11.8331 2.08379 11.7151C2.11072 11.6104 2.15338 11.5105 2.21029 11.4188C2.27447 11.3153 2.36296 11.2264 2.53993 11.0487L11.2417 2.30865C11.5908 1.95805 12.136 1.89931 12.5511 2.16754C13.0433 2.48553 13.4638 2.9034 13.7857 3.39431L13.8082 3.42871C13.8245 3.45358 13.8327 3.46601 13.8396 3.47721C14.0951 3.88885 14.0411 4.42196 13.7081 4.77337C13.6991 4.78293 13.6886 4.79345 13.6676 4.81451L5.01874 13.5014C4.83516 13.6858 4.74337 13.7779 4.63623 13.8439C4.54125 13.9023 4.43769 13.9452 4.32937 13.9712C4.20719 14.0005 4.07739 14.0003 3.81777 13.9999L2 13.997L2.04411 12.2101Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                            <span className="ms-2">
                                                Campaign
                                            </span>
                                        </th>
                                        <th scope="col" className={`thead-padd`}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                                            <path d="M7.71153 1L1.37422 8.4815C1.12603 8.7745 1.00194 8.921 1.00004 9.04472C0.998392 9.15228 1.04711 9.25461 1.13216 9.32223C1.22999 9.4 1.42383 9.4 1.81151 9.4H7L6.28847 15L12.6258 7.5185C12.874 7.2255 12.9981 7.079 13 6.95528C13.0016 6.84772 12.9529 6.74539 12.8678 6.67777C12.77 6.6 12.5762 6.6 12.1885 6.6H7L7.71153 1Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                            <span className="ms-2">
                                            View Lead Page
                                            </span>
                                        </th>
                                        <th scope="col" className={`thead-padd`}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                            <path d="M5.79319 7.60401C6.05232 7.95079 6.38293 8.23773 6.76259 8.44537C7.14225 8.653 7.56208 8.77647 7.9936 8.80741C8.42512 8.83834 8.85824 8.77602 9.26358 8.62466C9.66893 8.47331 10.037 8.23646 10.3429 7.93018L12.1531 6.11814C12.7027 5.54855 13.0068 4.78567 12.9999 3.99382C12.993 3.20197 12.6757 2.4445 12.1163 1.88456C11.557 1.32461 10.8002 1.007 10.0092 1.00011C9.21813 0.993233 8.45602 1.29764 7.88701 1.84777L6.84915 2.88063M8.20681 6.39599C7.94768 6.04921 7.61707 5.76227 7.23741 5.55463C6.85775 5.347 6.43792 5.22353 6.0064 5.19259C5.57488 5.16166 5.14176 5.22398 4.73642 5.37534C4.33107 5.52669 3.96299 5.76354 3.65713 6.06982L1.84692 7.88186C1.29734 8.45145 0.99324 9.21433 1.00011 10.0062C1.00699 10.798 1.32429 11.5555 1.88367 12.1154C2.44305 12.6754 3.19976 12.993 3.99081 12.9999C4.78187 13.0068 5.54397 12.7024 6.11299 12.1522L7.14482 11.1194" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                            <span className="ms-2">
                                                Copy Link
                                            </span>
                                        </th>
                                        {
                                            variables?.length > 0 && variables?.filter(val => !predefinedVariables?.has(val)).map((val,index)=>(
                                                <th scope="col" className={`thead-padd`}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                                                        <path d="M13.6389 4.64614L7.49998 7.99998M7.49998 7.99998L1.36109 4.64614M7.49998 7.99998L7.5 14.7471M14 10.8825V5.11752C14 4.87416 14 4.75249 13.9635 4.64396C13.9313 4.54796 13.8786 4.45983 13.8089 4.38548C13.7301 4.30143 13.622 4.24234 13.4056 4.12416L8.06119 1.20435C7.85636 1.09245 7.75395 1.0365 7.64549 1.01456C7.5495 0.995146 7.4505 0.995146 7.35451 1.01456C7.24605 1.0365 7.14364 1.09245 6.93881 1.20435L1.59437 4.12416C1.37805 4.24234 1.26988 4.30144 1.19112 4.38548C1.12145 4.45983 1.06872 4.54796 1.03646 4.64397C1 4.75249 1 4.87416 1 5.11752V10.8825C1 11.1258 1 11.2475 1.03646 11.356C1.06872 11.452 1.12145 11.5402 1.19112 11.6145C1.26988 11.6986 1.37805 11.7577 1.59437 11.8758L6.93881 14.7957C7.14364 14.9076 7.24605 14.9635 7.35451 14.9854C7.4505 15.0049 7.5495 15.0049 7.64549 14.9854C7.75395 14.9635 7.85636 14.9076 8.06119 14.7957L13.4056 11.8758C13.622 11.7577 13.7301 11.6986 13.8089 11.6145C13.8786 11.5402 13.9313 11.452 13.9635 11.356C14 11.2475 14 11.1258 14 10.8825Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span className="ms-2">
                                                        {val}
                                                    </span>
                                                </th>
                                            ))
                                        }
                                        
                                        <th></th>
                                        {/* <th className={`thead-pad`}>
                                        </th>
                                        <th className={`th-end-`}></th>  */}
                                    </tr>
                                </thead>

                                {
                                    loading ?
                                        <tbody>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                        :
                                        <tbody>
                                            {
                                                allAudience?.data?.length > 0 && (
                                                    allAudience?.data?.map((val, index) => (
                                                        <tr key={index}>
                                                            <td scope="row">
                                                                <div className="lead-name-col">
                                                                {/* <label className="custom-checkbox checkbox"> */}
                                                                    <input className="ui-checkbox" type="checkbox" name="select-one" data-id={val.id} onChange={(e) => handleCheckboxChange(e, val.id)}/>
                                                                    {/* <span className="checkmark"></span>
                                                                </label> */}
                                                                <p class="mb-0 d-inline-flex align-items-center gap-2 justify-content-start">
                                                                    <span className="subscriber-logo">
                                                                        {
                                                                            val?.logo ?
                                                                            <img src={val?.logo} width={"100%"} alt="" />:
                                                                            <img src={userIcon} alt="" width={"100%"}/>
                                                                        }
                                                                    </span>
                                                                    {/* <span class="subscriber-name-icon me-2 d-md-flex d-none">{val?.name.substring(0, 1).toUpperCase()}</span> */}
                                                                    <span title={val?.name} class="d-flex align-items-start jusitfy-content-center flex-column">
                                                                        <span className="prodname">{val?.name}</span>
                                                                        {/* <span class="d-md-none d-block">{val?.email}</span> */}
                                                                    </span>
                                                                </p>
                                                                </div>
                                                            </td>
                                                            <td class="d-md-table-cell ps-0 prodname full-row" title={val?.email}>{val?.email}</td>
                                                            <td class="d-md-table-cell ps-0 prodname" title={val?.company_name}>{val?.company_name}</td>
                                                            {/* <td class="d-md-table-cell d-none thead-padd">{setDateFormat(val?.created_at)}</td> */}
                                                            <td class="d-md-table-cell ps-0 prodname full-row">
                                                                <div className="btn-fafafa border-radius-9 cursor-pointer" onClick={() => {editProduct(val?.product)}}>
                                                                    <span className="box-18f">
                                                                    </span>
                                                                    <span>
                                                                    <div className="text-decoration-none text-dark">
                                                                        {val?.product?.name}
                                                                    </div>
                                                                    </span>
                                                                </div>
                                                            </td>
                                                            <td className="view-link-td">
                                                                <button key={val.id} disabled={generatingStates[index]} onClick={() => handleGenerate(val, index)} className="view-landing-page overflow-hidden">
                                                                    {!val?.is_exported &&
                                                                    <span className={`d-flex align-items-center gap-1 justify-content-center ${generatingStates[index] ? 'generate-page' : ''}`}>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                                                        <g stroke="#1188FF" fill="transparent" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                                                            <path d="M23 4v6h-6M1 20v-6h6" />
                                                                            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
                                                                        </g>
                                                                        </svg>
                                                                        {generatingStates[index] ? 'Generating...' : 'Generate Landing Page'}
                                                                    </span>
                                                                    }
                                                                    <span className={`d-flex align-items-center gap-1 justify-content-center landing-page-text landing-page-text-${val.id} ${val?.is_exported ? 'opacity-1': 'opacity-0'}`}>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                                                        <rect x="10.3594" y="3.86816" width="1.348" height="10.11" rx="0.673998" transform="rotate(45 10.3594 3.86816)" fill="#1188FF" />
                                                                        <rect x="11.4492" y="3.52637" width="1.38781" height="6.93906" rx="0.693906" transform="rotate(90 11.4492 3.52637)" fill="#1188FF" />
                                                                        <rect width="1.38781" height="6.93906" rx="0.693906" transform="matrix(-1 0 0 1 11.5312 3.60938)" fill="#1188FF" />
                                                                        </svg>
                                                                        View Landing Page
                                                                    </span>
                                                                </button>
                                                            </td>
                                                            <td className="copy-link-td">
                                                                <button onClick={()=>copyLink(val)} disabled={!val?.is_exported} className="bg-transparent btn-fafafa border-radius-9">
                                                                    <span className="box-18f">
                                                                    </span>
                                                                    <span>
                                                                    <div className="text-decoration-none text-dark">
                                                                            Copy Link
                                                                    </div>
                                                                    </span>
                                                                </button>
                                                            </td>
                                                            {
                                                                variables?.length > 0 && variables?.filter(variable => !predefinedVariables?.has(variable)).map((variable, varIndex) => {
                                                                    const matchedData = val.data.find(dataItem => dataItem?.key === variable);
                                                                    return (
                                                                        <td className="d-md-table-cell ps-0 prodname" title={matchedData ? matchedData.value : ''} key={varIndex}>
                                                                            {matchedData ? matchedData.value : ''}
                                                                        </td>
                                                                    );
                                                                })
                                                            }
                                                            
                                                            <td>
                                                                <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end dropdown-subscribers" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false" >
                                                                    <img src={dotsIcon} width="" alt="" />
                                                                </div>
                                                                <ul class="dropdown-menu" aria-labelledby="table-action-dropdown">
                                                                    <li><a class="dropdown-item" onClick={()=>copyLink(val)}><span class="me-5">Copy Link URL</span><ChevronRight /></a></li>                                                                    
                                                                    <li><a class="dropdown-item" onClick={()=>editLead(val)}><span class="me-5">Edit Lead</span><ChevronRight /></a></li>                                                                    
                                                                    <li><a class="dropdown-item theme-active semi-bold" onClick={() =>
                                                                        setconfirmationModalShow({
                                                                            show: true, text: "Are you sure you want to delete this Lead?", id: val?.id, callBackTo: "delete", deleteAll: false
                                                                        })} ><span class="me-5">Delete Lead</span><ChevronRight /></a></li>
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}

                                        </tbody>

                                }
                            </table>
                        </div>

                        <div>
                        {selectedRows?.length > 0 &&
                            <div className="">
                                &nbsp; &nbsp;
                                “{selectType == 'all' ? allAudience?.total - unChecked?.length : selectedRows?.length  }” leads selected.
                            </div>
                        }
                        <div class="section-footer d-flex align-items-center justify-content-between">
                            <CommunityFooter loading={loading} from={"leads"} filter={filter} setfilter={setfilter} total={allAudience?.total} last_page={allAudience?.last_page} current_page={allAudience?.current_page}/>
                        </div>
                        </div>

                    </div>
                    }
                </section>
            </div>
            <ImportModal callAudience={callAudience} show={showImportModal} setshowImportModal={setshowImportModal} handleHide={handleHide} />
            {confirmationModalShow?.show && (
                <ConfirmationModal
                    confirmationModalShow={confirmationModalShow}
                    setShow={setconfirmationModalShow}
                    setisConfirmMessage={setisConfirmMessage}
                    callback={() => {
                        if (confirmationModalShow?.deleteAll) {
                            deleteAllAudience(confirmationModalShow?.id);
                        } else {
                            deleteAudience(confirmationModalShow?.id);
                        }
                    }}
                />
            )}
            {showEditLead?.show && <EditLead show={showEditLead} setShow={setShowEditLead} callAudience={callAudience}/>}
        </div>
    )
}
export default Audience